import styled from 'styled-components';

export const Container = styled.section`
  zoom: ${({ isBuilder }) => (isBuilder ? '0.3' : 'normal')};
`;
Container.displayName = 'Container';

export const Image = styled.img`
  height: 1080px;
  object-fit: cover;
  object-position: center center;
  width: 1920px;
`;
Image.displayName = 'Image';
